module.exports = __webpack_public_path__ + "static/media/delete.57350d04.svg";